import { render, staticRenderFns } from "./PaymentOwnerPatientDetail.vue?vue&type=template&id=ffa21c76&scoped=true&"
import script from "./PaymentOwnerPatientDetail.vue?vue&type=script&lang=js&"
export * from "./PaymentOwnerPatientDetail.vue?vue&type=script&lang=js&"
import style0 from "./PaymentOwnerPatientDetail.vue?vue&type=style&index=0&id=ffa21c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa21c76",
  null
  
)

export default component.exports